"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBaseExtremum = void 0;
const getBaseExtremum = params => {
  const {
    axis
  } = params;
  const minX = Math.min(...(axis.data ?? []));
  const maxX = Math.max(...(axis.data ?? []));
  return [minX, maxX];
};
exports.getBaseExtremum = getBaseExtremum;